import { json } from '@remix-run/node'
import { useLoaderData } from '@remix-run/react'
import { H2 } from '#app/components/typography/h2.tsx'
import { readSource } from '../sections/sections.server.tsx'
import { Description, Features, Source, type componentProps, Parts, Usage, Styling } from '../sections/sections.tsx'

export const handle = {
	breadcrumb: 'H2',
}

const component: componentProps = {
	name: 'H2',
	shortName: 'H2',
	fileName: 'h2',
	category: 'typography',
	description: ['H2 heading component.'],
	features: ['Drop-in replacement for the native <h2> element.', "Opts-in to your design system's typographic styles."],
	parts: [],
	usage: `<H2>This is an h2 heading</H2>`,
	styling: `.h2 {
	@apply text-muted-900 mt-fluid-14 mb-fluid-11 text-fluid-3xl max-w-prose font-sans font-bold capitalize;
	/* If h2 has h3 after it */
	&:has(+ .h3) {
		@apply mb-fluid-9;
	}
	/* Typographical elements after h2 */
	& + .h3,
	& + .p {
		@apply mt-0;
	}
}`,
}

export const loader = async () => {
	const source = await readSource({ category: component.category, fileName: component.fileName })
	return json({ source })
}

const HeadingRoute = () => {
	const { source } = useLoaderData<typeof loader>()
	const { name, description, shortName, fileName, features, usage, parts, styling } = component

	return (
		<>
			<Description name={name} description={description} />
			<Usage usage={usage} shortName={shortName} />
			<H2>This is an h2 heading</H2>
			<Features features={features} />
			<Parts parts={parts} />
			<Source source={source} fileName={fileName} />
			<Styling styling={styling} />
		</>
	)
}
export default HeadingRoute
